import * as moment from 'moment';

const mm = () => {
	return moment.default;
}

interface IData {
	expire: number;
	data: any;
};
export class StorageService {
	setData(key: string, data: any, expiration?: number) {
		if (typeof Storage === "undefined")
			return;
		let item = JSON.stringify({ expire: expiration ? moment.utc().add(expiration, 'seconds').unix() : 0, data: data });
		if (key.startsWith('#')) {
			window.sessionStorage.setItem(key.substring(1), item);
		}
		else {
			window.localStorage.setItem(key, item);
		}
	};

	getData(key: string, dataDefault?: any) {
		if (typeof Storage === "undefined")
			return null;
		let item: IData;
		if (key.startsWith('#')) {
			item = JSON.parse(window.sessionStorage.getItem(key.substring(1)));
		}
		else {
			item = JSON.parse(window.localStorage.getItem(key));
		}

		return item && (item.expire === 0 || moment.utc().unix() > item.expire) ? item.data : dataDefault;
	};

	remove(key: string) {
		if (key.startsWith('#')) {
			window.sessionStorage.removeItem(key.substring(1));
		}
		else {
			window.localStorage.removeItem(key);
		}
	};
}
